import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DynamicDialogRef, DynamicDialogConfig, DialogService } from 'primeng/dynamicdialog';

@Component({
    selector: 'app-recommended-differ-tire-size',
    templateUrl: './tire-size-different-recommended-dialog.component.html',
    styleUrls: ['./tire-size-different-recommended-dialog.component.scss'],
    providers: [DialogService],
})
export class TireRecommendedSizeComponent implements OnInit {
    recommendedSizes: any[] = [];
    cartSizes: any[] = []
    constructor(
        private dialogService: DialogService,
        private dynamicDialogRef: DynamicDialogRef,
        private dynamicDialogConfig: DynamicDialogConfig,
      ) {}
    ngOnInit() {
        const { recommendedSizes, cartSizes } = this.dynamicDialogConfig.data;
        this.cartSizes = cartSizes;
        this.recommendedSizes = recommendedSizes;
    }

    handleClose(isSuccess: boolean = false) {
        this.dynamicDialogRef.close({ isSuccess });
    }
}